<template>
  <v-container fluid class="review-select">
    <!-- <v-row class="mt-1">
      <v-col
        v-if="options.depth1"
        class="d-flex py-0"
        cols="12"
        sm="12"
      >
        <v-select
          v-model="selected1"
          :items="replaceDelimiter(options.depth1.items)"
          :label="options.depth1.title"
          height="48"
          solo
          flat
          outlined
          dense
          @change="depth1Change()"
        ></v-select>
      </v-col>
      <v-col
        v-if="optionsDepth2.items.length > 0"
        class="d-flex py-0 mt-n4"
        cols="12"
        sm="12"
      >
        <v-select
          v-model="selected2"
          :items="replaceDelimiter(optionsDepth2.items)"
          :label="optionsDepth2.title"
          height="48"
          solo
          flat
          outlined
          dense
          @change="depth2Change()"
        ></v-select>
      </v-col>
      <v-col
        v-if="optionsDepth3.items.length > 0"
        class="d-flex py-0 mt-n4"
        cols="12"
        sm="12"
      >
        <v-select
          v-model="selected3"
          :items="replaceDelimiter(optionsDepth3.items)"
          :label="optionsDepth3.title"
          height="48"
          solo
          flat
          outlined
          dense
          @change="depth3Change()"
        ></v-select>
      </v-col>
      <v-col
        v-if="optionsDepth4.items.length > 0"
        class="d-flex py-0 mt-n4"
        cols="12"
        sm="12"
      >
        <v-select
          v-model="selected4"
          :items="replaceDelimiter(optionsDepth4.items)"
          :label="optionsDepth4.title"
          height="48"
          solo
          flat
          outlined
          dense
          @change="depth4Change()"
        ></v-select>
      </v-col>
    </v-row> -->
    <v-row class="mx-n4 mt-n2">
      <v-col
        v-for="(item, i) in images"
        :key="i"
        class="d-flex child-flex pa-1"
        cols="4"
        @click="thumbLinkClick()"
      >
      <div v-if="item.revwTyp=='OneMonnRevw'">
          <div class="month-grey" >한달사용</div>
        <thumbnail
        class ="thumbnail"
          :index="i"
          :item="item"
        >
        </thumbnail>
      </div>
      <div v-else>
          <thumbnail
          :index="i"
          :item="item"
        />
      </div>
      </v-col>
    </v-row>
    <v-card
      class="mt-2"
      height="100"
      v-intersect="{
        handler: onIntersect,
        options: {
          threshold: [0]
        }
      }"
      elevation="0"
    >
    </v-card>
  </v-container>
</template>

<script>
import store from '@/store'
import idb from 'localforage'
import Thumbnail from '../components/Thumbnail'

export default {
  name: 'List',
  components: {
    Thumbnail,
  },
  data () {
    return {
      loadFlag: true,
      images: store.state.items,
      options: store.state.options,
      optionsDepth2: {
        title: "",
        items: []
      },
      optionsDepth3: {
        title: "",
        items: []
      },
      optionsDepth4: {
        title: "",
        items: []
      },
      selected1: "",
      selected2: "",
      selected3: "",
      selected4: "",
    }
  },
  methods: {
    async onIntersect (entries) {
      if(entries[0].isIntersecting) {
        if(this.loadFlag) {
          this.loadFlag = false;
          let optNm = (this.selected1 ? this.selected1 : "")
            + (this.selected2 ? ("/" + this.selected2) : "");
            + (this.selected3 ? ("/" + this.selected3) : "");
            + (this.selected4 ? ("/" + this.selected4) : "");
          // if(this.selected1) { optNm = this.selected1; }
          // if(this.selected2) { optNm += "/" + this.selected2; }
          // if(this.selected3) { optNm += "/" + this.selected3; }
          // if(this.selected4) { optNm += "/" + this.selected4; }
          let moreList = [];
          if(optNm) {
            moreList = await store.dispatch("MORE_ITEMS_WITH_OPTION", optNm);
          } else {
            moreList = await store.dispatch("MORE_ITEMS");
          }
          if(moreList) {
            this.images.concat(moreList);
          }
          this.loadFlag = true;
        }
      }
    },
    replaceDelimiter(items) {
      return items.map((str)=>{
        return str.replace(/뿗/i, '/');
      });
    },
    depth1Change() {
      this.setSelectedItem(1);
      if(this.options.depth2) {
        this.optionsDepth2.title = this.options.depth2.title;
        this.options.depth2.items[this.selected1].forEach(data => {
          this.optionsDepth2.items.push(data);
        });
        this.optionsDepth3 = {title:"",items:[]};
        this.optionsDepth4 = {title:"",items:[]};
      } else {
        this.submit(this.selected1);
        // (async() =>{
        //   await store.dispatch("FETCH_ITEMS_WITH_OPTION", {prdcd: this.$route.params.prdcd, optNm: this.selected1});
        //   this.images = store.state.items;
        // })();
      }
    },
    depth2Change() {
      this.setSelectedItem(2);
      if(this.options.depth3) {
        this.optionsDepth3.title = this.options.depth3.title;
        this.options.depth3.items[this.selected1 + "뿗" + this.selected2].forEach(data => {
          this.optionsDepth3.items.push(data);
        });
        this.optionsDepth4 = {title:"",items:[]};
      } else {
        this.submit(this.selected1 + "/" + this.selected2);
        // (async() =>{
        //   await store.dispatch("FETCH_ITEMS_WITH_OPTION", {prdcd: this.$route.params.prdcd, optNm: this.selected1 + "/" + this.selected2});
        //   this.images = store.state.items;
        // })();
      }
    },
    depth3Change() {
      this.setSelectedItem(3);
      if(this.options.depth4) {
        this.optionsDepth4.title = this.options.depth4.title;
        this.options.depth4.items[this.selected1 + "뿗" + this.selected2 + "뿗" + this.selected3].forEach(data => {
          this.optionsDepth4.items.push(data);
        });
      } else {
        this.submit(this.selected1 + "/" + this.selected2 + "/" + this.selected3);
        // (async() =>{
        //   await store.dispatch("FETCH_ITEMS_WITH_OPTION", {prdcd: this.$route.params.prdcd, optNm: this.selected1 + "/" + this.selected2 + "/" + this.selected3});
        //   this.images = store.state.items;
        // })();
      }
    },
    depth4Change() {
      this.setSelectedItem(4);
      this.submit(this.selected1 + "/" + this.selected2 + "/" + this.selected3 + "/" + this.selected4);
      // (async() =>{
      //   await store.dispatch("FETCH_ITEMS_WITH_OPTION", {prdcd: this.$route.params.prdcd, optNm: this.selected1 + "/" + this.selected2 + "/" + this.selected3 + "/" + this.selected4});
      //   this.images = store.state.items;
      // })();
    },
    async setSelectedItem(order) {
      if(order == 1) {
        // console.log("test1");
        await idb.setItem('selected1', this.selected1);
        await idb.setItem('selected2', "");
        await idb.setItem('selected3', "");
        await idb.setItem('selected4', "");
        this.selected2 = "";
        this.selected3 = "";
        this.selected4 = "";
      } else if(order == 2) {
        // console.log("test2", this.selected2);
        await idb.setItem('selected2', this.selected2);
        await idb.setItem('selected3', "");
        await idb.setItem('selected4', "");
        this.selected3 = "";
        this.selected4 = "";
        // console.log("test21", this.selected2);
      } else if(order == 3) {
        // console.log("test3");
        await idb.setItem('selected3', this.selected3);
        await idb.setItem('selected4', "");
        this.selected4 = "";
      } else if(order >= 4) {
        await idb.setItem('selected4', this.selected4);
        // await idb.setItem('selected4', this.selected4);
      }
    },
    async submit(optNm) {
      // console.log("optNm", optNm);
      await store.dispatch("FETCH_ITEMS_WITH_OPTION", {prdcd: this.$route.params.prdcd, optNm: optNm});
      this.images = store.state.items;
    },
    thumbLinkClick() {
      sendAmplitudeCodeAction(store.state.prdcd, '', '', '상품평_갤러리_전체보기_썸네일', true);
    },
  },
  async mounted() {
    // if("Y" == await idb.getItem('checkFromThumbList')) {
    //   this.selected1 = await idb.getItem('selected1');
    //   if("" != this.selected1 && this.options.depth2) {
    //     this.optionsDepth2.title = this.options.depth2.title;
    //     this.options.depth2.items[this.selected1].forEach(data => {
    //       this.optionsDepth2.items.push(data);
    //     });
    //   }
    //   this.selected2 = await idb.getItem('selected2');
    //   if("" != this.selected2 && this.options.depth3) {
    //     this.optionsDepth3.title = this.options.depth3.title;
    //     this.options.depth3.items[this.selected1 + "뿗" + this.selected2].forEach(data => {
    //       this.optionsDepth3.items.push(data);
    //     });
    //   }
    //   this.selected3 = await idb.getItem('selected3');
    //   if("" != this.selected3 && this.options.depth4) {
    //     this.optionsDepth4.title = this.options.depth4.title;
    //     this.options.depth4.items[this.selected1 + "뿗" + this.selected2 + "뿗" + this.selected3].forEach(data => {
    //       this.optionsDepth4.items.push(data);
    //     });
    //   }
    //   this.selected4 = await idb.getItem('selected4');
    // }
  }
}
</script>

<style lang="scss">
.review-conts-detail .help-txt {
  font-size: 14px;
  line-height: 56px;
  color: rgba(17,17,17,.6);
  letter-spacing: -0.4px;
}
.v-text-field__details {
  min-height: 4px !important;
}
.review-select {
  overflow: hidden;
  .mdi-menu-down::before {
    content:'';
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M18.25 8a.736.736 0 0 0-.53.227L12 14.132 6.28 8.227a.736.736 0 0 0-1.06 0 .793.793 0 0 0 0 1.095l6.248 6.451A.735.735 0 0 0 12 16h.002a.733.733 0 0 0 .53-.227l6.25-6.451a.793.793 0 0 0 0-1.095.736.736 0 0 0-.53-.227' fill='%23191923' fill-rule='evenodd' fill-opacity='.64'/%3E%3C/svg%3E");
  }
  .theme--light.v-label {
    font-weight: bold;
    color: #191923
  }
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color: #e2e2ea;
  }
  .v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
    border:1px solid #e2e2ea
  }
}
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
    font-size: 16px !important;
    letter-spacing: -0.4px;
    color: rgba(25, 25, 35, 0.88) !important;
    line-height: 2em !important; 
    font-family: -apple-system,BlinkMacSystemFont,"Roboto","Segoe UI","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",helvetica,sans-serif;
}

.v-application .d-flex {
  position: relative;
}
.month-grey {
    position: absolute;
    top: 4px;
    left: 4px;
    display: inline-block;
    height: 24px;
    background-color: rgba(0, 0, 0, 0.32);
    color: white;
    padding: 0 7px;
    font-weight: bold;
    font-size: 12px;
    line-height: 24px;
    z-index: 2;
}

</style>